import React, { forwardRef, useEffect, useState, useImperativeHandle } from 'react'
import { Row, Col, DatePicker, Button, TimePicker,  message } from 'antd'
import PushTimePicker from './PushTimePicker';
import { PlusCircleFilled, CloseCircleFilled, CheckOutlined, CloseOutlined } from '@ant-design/icons'
import moment from 'moment'
import './WeekdaySchedulerEditor.css'
import { connect } from 'react-redux';
import { requestServerPost, requestServerGet, selectPage } from '../actions';
import Cleave from 'cleave.js/react';
import { RxLapTimer } from "react-icons/rx";
import { CgSandClock } from "react-icons/cg";
import { TbRepeat, TbRepeatOff } from "react-icons/tb";

import { Space, Switch } from 'antd';
import MomentHelper from '../helpers/MomentHelper';


const { RangePicker } = DatePicker;

const WeekdaySchedulerEditor = forwardRef((props, ref) => {


    const weekdays = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"]
    const weekdayNums = [1, 2, 3, 4, 5, 6, 0]
    const { data } = props;
    const { WeekDay, StartTime, EndTime, StartDate, EndDate } = data;
    // const [schedules, setSchedules] = useState({ WeekDay: [], StartTime: "", EndTime: "", StartDate: "", EndDate: "" })
    const [scData, setScData] = useState(null)
    const [days, setDays] = useState([])
    const [startTime, setStartTime] = useState("")
    const [endTime, setEndTime] = useState("")
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [repeatEvery, setRepeatEvery] = useState("")
    const [repeatDuration, setRepeatDutation] = useState("")
    const [useRecuringPlayback, setUseRecuringPlayback] = useState(false)
  

    // const dateFormat = 'YYYY/MM/DD';
    const dateFormat = 'DD/MM/YYYY';
    const inputdateFormat = 'YYYY-MM-DD';
    const inputformat = 'HH:mm:ss';
    const format = 'HH:mm';
    const timeInputStyle = {
        backgroundColor: "#4C4D52",
        borderRadius: "4px",
        overflow: "hidden",
        color: "white !important",
        fontColor: "white !important",
        fontWeight: 600,
        height: "50px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }

    useEffect(() => {

        const { onSave = () => { }, data, requestServerPost, usertoken } = props;
        //setScData(data)
        reloadFromProps();
        // setSchedules({ weekDays, StartTime: StartTime, EndTime: EndTime, StartDate: StartDate, EndDate: EndDate })
        return () => {
            console.log('cleaned up');
        };
    }, [])

    const reloadFromProps = () => {
        const { data } = props;
        setScData(data)

        if (!data)
            return
        const { WeekDay, StartTime, EndTime, StartDate, EndDate, RepeatEvery, RepeatDuration } = data;
        const weekDays = WeekDay.split(',')

        setDays(weekDays)
        setStartTime(StartTime)
        setEndTime(EndTime)
        setStartDate(StartDate)
        setEndDate(EndDate)
        if(!RepeatEvery || !RepeatDuration)
        {

            setUseRecuringPlayback(false);
            setRepeatEvery("")
            setRepeatDutation("")
        }
        else
        {
            setUseRecuringPlayback(true);
            setRepeatEvery(RepeatEvery)
            setRepeatDutation(RepeatDuration)
        }
    }

    useImperativeHandle(ref, () => ({

        resetUnsavedChanged() {
            reloadFromProps();
        }

    }));

    const onDurationChanged = (newDurationMoment, fieldName) => {

        const seconds = MomentHelper.getSecondsDuration(newDurationMoment)

        switch (fieldName) {
            case "repeatEvery":
                setRepeatEvery(seconds);
                break;
            case "repeatDuration":
                setRepeatDutation(seconds)
                break;
        }
    }

    const save = () => {
        const { onSave = () => { }, data, requestServerPost, usertoken } = props;

        const params = new FormData();
        const { TimelineScheduleID, TimelineID } = scData;

        params.append("timelinescheduleid", TimelineScheduleID)
        params.append("timelineid", TimelineID)
        params.append("weekday", days.join(","))
        params.append("starttime", startTime)
        params.append("endtime", endTime)
        params.append("startdate", startDate)
        params.append("enddate", endDate)

        var repeatEveryValue = "";
        var repeatDurationValue = "";

        if (useRecuringPlayback) {
            if(repeatEvery !== "" && repeatDuration !== "")
            {

                console.log("has repeat" + repeatEvery + " " + repeatDuration)
                repeatEveryValue = repeatEvery;
                repeatDurationValue = repeatDuration;
            }
            else
            {
                console.log("has unset repeat" + repeatEvery + " " + repeatDuration)
                message.warning('"Repeat Every" and "Duration per Round" must be set to enable recurring playback');
                return;
            }

        }
        
        params.append("repeatEvery", repeatEveryValue)
        params.append("repeatDuration", repeatDurationValue)
        


        requestServerPost("update_timelineschedule", params, { }, (response) => {
            onSave({ WeekDay: days.join(","), StartTime: startTime, EndTime: endTime, StartDate: startDate, EndDate: endDate, RepeatEvery:repeatEveryValue, RepeatDuration:repeatDurationValue })
        }, usertoken);
    }
    const addStartEndTime = () => {
        setStartTime("00:00:00");
        setEndTime("23:59:59");
    }
    const addStartEndDate = () => {
        setStartDate(moment().format(inputdateFormat));
        setEndDate(moment().format(inputdateFormat));
        // console.log(moment().format("YYYY-MM-DD"))
        // this.setState({ StartDate: "00:00:00", EndDate: "23:59:59" })
    }
    const onStartEndDateChanged = (moments, value) => {
        setStartDate(moments[0].format(inputdateFormat));
        setEndDate(moments[1].format(inputdateFormat));
    }
    const onStartTimeChanged = (moment, value) => {
        // console.log("onStartTimeChanged ")
        if (!moment)
            return;
        // console.log("onStartTimeChanged " + moment.format(inputformat))
        moment.second(0);
        setStartTime(moment.format(inputformat));
    }
    const onEndTimeChanged = (moment, value) => {
        // console.log("onEndTimeChanged")
        if (!moment)
            return;
        moment.second(0);
        setEndTime(moment.format(inputformat));
    }
    return (
        <Row gutter={16} style={{ width: "min(480px, 92vw)" }} justify="space-between">
            <Col span={24} style={{ height: "50px" }}>
                <div style={{ display: "flex", width: "100%", borderRadius: "4px", overflow: "hidden" }}>
                    {weekdays.map((day, index) => {
                        const activeStyle = { backgroundColor: "#5F92F8", color: "#ffffff" }
                        const inactiveStyle = { backgroundColor: "#EEEEEE", color: "#DEDEDE" }
                        const isActive = days.indexOf(`${weekdayNums[index]}`) !== -1
                        const selectedStyle = isActive ? activeStyle : inactiveStyle;
                        return <div onClick={() => {
                            if (isActive) {
                                const newDays = days.filter((d) => {
                                    return d !== `${weekdayNums[index]}`
                                })
                                setDays(newDays)
                            }
                            else {
                                setDays([...days, `${weekdayNums[index]}`])
                            }
                        }} className="center-content" style={{ flex: 1, height: "40px", fontSize: "13px", cursor: "pointer", ...selectedStyle }}>{day}</div>
                    })}
                </div>
            </Col>
            <Col className="center-content schedule-picker" span={11} style={{ height: "50px" }}>
                {(startTime == "" && endTime == "") ? <Button type="text" onClick={addStartEndTime} icon={<PlusCircleFilled></PlusCircleFilled>}>Add Specific Time</Button> : (
                    <Row justify="start">
                        <Col className="center-content weekdayscheduler-timeinput" span={10}>
                            {/* <Cleave placeholder="HH:MM" style={{
                                backgroundColor: "transparent",
                                outlineWidth: 0,
                                outline: "none",
                                border: "none",
                                textAlign: "center"
                            }}
                                options={{ time: true, timePattern: ['h', 'm'] }}
                            // onFocus={onStartTimeChanged}
                            // onChange={onStartTimeChanged} 
                            /> */}
                            <PushTimePicker
                                allowClear={false}
                                bordered={false}
                                suffixIcon={null}
                                // onChange={onStartTimeChanged}
                                onSelect={onStartTimeChanged}
                                value={moment(startTime, inputformat)}
                                defaultValue={moment(startTime, inputformat)}
                                format={format} ></PushTimePicker>
                        </Col>
                        <Col className="center-content" span={2}>
                            -
                        </Col>
                        <Col className="center-content weekdayscheduler-timeinput" span={10}>
                            <PushTimePicker
                                allowClear={false}
                                bordered={false}
                                suffixIcon={null}
                                // onChange={onEndTimeChanged}
                                value={moment(endTime, inputformat)}
                                onSelect={onEndTimeChanged}
                                defaultValue={moment(endTime, inputformat)}
                                format={format} ></PushTimePicker>
                            {/* <Cleave placeholder="HH:MM" style={{
                                backgroundColor: "transparent",
                                outlineWidth: 0,
                                outline: "none",
                                border: "none",
                                textAlign: "center"
                            }}
                                options={{ time: true, timePattern: ['h', 'm'] }}
                            // onFocus={onStartTimeChanged}
                            // onChange={onStartTimeChanged} 
                            /> */}
                        </Col>
                        <Col>
                            <div onClick={(e) => {
                                setStartTime("");
                                setEndTime("");
                                e.preventDefault();
                            }} className="btn-remove-item" style={{ position: "absolute", right: "-26px", top: "8px" }}>
                                <CloseCircleFilled style={{ color: "rgb(221, 221, 221)", cursor: "pointer", fontSize: "20px" }} />
                            </div>
                        </Col>
                    </Row>

                )}
            </Col>
            <Col className="center-content schedule-picker" span={11} style={{ height: "50px" }}>
                {(startDate == "" && endDate == "") ? <Button onClick={addStartEndDate} type="text" icon={<PlusCircleFilled></PlusCircleFilled>}>Add Specific Date</Button> : (
                    <Row justify="center" style={{ marginRight: "26px" }}>
                        <Col className="center-content weekdayscheduler-dateinput">
                            <RangePicker
                                size="small"
                                allowClear={false}
                                bordered={false}
                                suffixIcon={null}
                                onChange={onStartEndDateChanged}
                                separator="-"
                                defaultValue={[moment(startDate, inputdateFormat), moment(endDate, inputdateFormat)]}
                                format={dateFormat} />
                        </Col>
                        <Col>
                            <div onClick={(e) => {
                                setStartDate("");
                                setEndDate("");
                                e.preventDefault();
                            }} className="btn-remove-item" style={{ position: "absolute", right: "-26px", top: "8px" }}>
                                <CloseCircleFilled style={{ color: "rgb(221, 221, 221)", cursor: "pointer", fontSize: "20px" }} />
                            </div>
                        </Col>
                    </Row>
                )}
            </Col>
            <Col className="center-content schedule-picker" span={24} style={{ height: "50px", display: "flex", justifyContent: "start", alignItems: "center", gap: "8px" }}>
                {/* <TbRepeat style={{position:"absolute", fontSize:"1.5em", left:"10px"}}/> */}
                <Switch
                    // checkedChildren={<TbRepeat />}
                    // unCheckedChildren={<TbRepeatOff />}
                    onChange={(checked) => { setUseRecuringPlayback(checked) }}
                    checked={useRecuringPlayback}
                />
                Enable Recurring Playback
            </Col>
            {useRecuringPlayback && <Col className="center-content schedule-picker" span={24} style={{ height: "100px" }}>

                <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: "5px", justifyContent: "center", alignItems: "start", fontSize: "1em", backgroundColor: "#f6f6ff", color: "#444", padding: "0.5em", borderRadius: "0.8em", border: "1px dashed #dadada" }}>
                    <div style={{ display: "flex", width: "100%", gap: "3px", justifyContent: "space-between", alignItems: "center" }}><span style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}><RxLapTimer />Repeat Every :</span><TimePicker defaultValue={moment.utc(moment.duration(repeatEvery, "seconds").asMilliseconds())} onChange={(durationmoment) => { onDurationChanged(durationmoment, "repeatEvery") }} className="duration-picker" size="medium" allowClear={false} bordered={false} showNow={false} placeholder="Pick Duration" />

                    </div>
                    <div style={{ display: "flex", width: "100%", gap: "3px", justifyContent: "space-between", alignItems: "center" }}><span style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}><CgSandClock />Duration per Round :</span><TimePicker defaultValue={moment.utc(moment.duration(repeatDuration, "seconds").asMilliseconds())} onChange={(durationmoment) => { onDurationChanged(durationmoment, "repeatDuration") }} className="duration-picker" size="medium" allowClear={false} bordered={false} showNow={false} placeholder="Pick Duration" /></div>
                </div>
            </Col>}

            <Col span={24}>
                <Row justify="end">
                    <Col>
                        <Button onClick={save} type="primary">SAVE</Button>
                    </Col>

                </Row>
            </Col>
        </Row >
    )
});

const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData };
}

export default connect(mapStateToProps, { requestServerGet, requestServerPost, selectPage })(WeekdaySchedulerEditor);
